function getRenderMeasurements(
	canvasWidth: number,
	canvasHeight: number,
	numberOfBricksX: number,
	numberOfBricksY: number,
) {
	const brickSizePixels = Math.min(
		canvasWidth / numberOfBricksX,
		canvasHeight / numberOfBricksY,
	);
	const ceilBrickSizePixels = Math.ceil(brickSizePixels);
	return {
		/** @deprecated this was marked deprecated, but I don't know why */
		ceilBrickSizePixels,
		brickSizePixels,
	};
}

export default getRenderMeasurements;
